export const stagesListConfig = {
  grid: "20px 1fr 26px 30px 60px 50px 1fr 80px 26px",
};
